import ExportButton from './src/main'

ExportButton.install = function (Vue) {
  Vue.component(ExportButton.name, ExportButton)
}

export default ExportButton
